<template>
  <div class="list-expenses">
    <div class="container-especific">
      <div>
        <div>
          <span class="black-font">Nome: {{nome}}</span>
        </div>
      </div>
      <br />
      <div class="filters-date">
        <div class="moth">
          <span class="mes black-font">Mês:</span>
          <b-form-select
            id="selectedMoth"
            @input="changeMoth"
            class="selected-moth"
            :options="months"
            v-model="currentMoth"
            disabled
          ></b-form-select>
        </div>
        <div class="width-space-date"></div>
        <div class="year">
          <span class="black-font ano">Ano:</span>
          <b-form-input
            id="inputAno"
            @blur.native="changeYear"
            class="input-year rigth-especific"
            type="text"
            v-mask="dateYear"
            v-model="ano"
            disabled
          ></b-form-input>
        </div>
        <div class="width-space-date"></div>
        <div class="date">
          <span class="black-font ano">Data:</span>
          <b-form-input
            id="inputData"
            @blur.native="changeDate"
            class="input-date rigth-especific"
            type="text"
            v-mask="dateMask"
            v-model="data"
            disabled
          ></b-form-input>
        </div>
      </div>
      <section>
        <h1 class="title"></h1>
      </section>
      <b-row>
        <div class="table-responsive">
          <b-table
            :items="beneficiosPorGrupo"
            :fields="fields"
            class="table specific table-specific-father"
          >
            <template v-slot:cell(slotBenGrupo)="row">
              <b-button
                size="sm"
                @click.stop="row.toggleDetails"
                @click="open(row.item.grupoCodigo)"
              >{{ row.detailsShowing ? '-' : '+'}}</b-button>
            </template>
            <template slot="row-details" slot-scope="rowPrincipal">
              <div class="table-responsive">
                <div v-if="!rowPrincipal.item.isCodeUser">
                  <TableGrups
                    :isAlreadyClosed="isAlreadyClosed"
                    :aprove="collaborator.aprove"
                    :beneficios="rowPrincipal.item.beneficios"
                    @listBeneficios="rowPrincipal.item.beneficios = $event"
                    @getBeneficio="changevalue($event)"
                  />
                </div>
                <div v-else>
                  <TableCodeUser
                    :isAlreadyClosed="isAlreadyClosed"
                    :aprove="collaborator.aprove"
                    :beneficiosCodeUser="rowPrincipal.item.beneficiosCodeUser"
                    @listBeneficios="rowPrincipal.item.beneficiosCodeUser = $event"
                    @getBeneficio="changevalue($event)"
                    @openCodeUser="openCodeUser($event.codeUser,$event.grupoCodigo)"
                  />
                </div>
              </div>
            </template>
          </b-table>
        </div>
      </b-row>

      <b-row>
        <b-col>
          <vs-textarea
            counter="500"
            label="Observações"
            :counter-danger.sync="counterDanger"
            v-model="observation"
          />
          <vs-button color="danger" @click="clickSaveObs" type="gradient">Salvar</vs-button>
        </b-col>
        <b-col class="rigth-especific">
          <div class="div-right-float">
            <div class="total-reembolso">
              <span class="reembolso margin-top-specific negrito">Total</span>
              <money
                v-model="total"
                v-bind="money"
                class="mask-input-invisible rigth-especific margin-top-specific mask-specific negrito"
                disabled
              ></money>
            </div>
            <div class="total-reembolso" style="margin-top:20px !important">
              <span class="reembolso left-especific margin-top-specific negrito">Total Pago</span>
              <money
                v-model="totalpago"
                v-bind="money"
                class="mask-input-invisible rigth-especific margin-top-specific mask-specific negrito"
                disabled
              ></money>
            </div>
          </div>
        </b-col>
      </b-row>
      <br />
      <hr />
      <b-row class="text-right">
        <b-col>
          <b-button @click="clickVisualize" variant="info">Visualizar</b-button>
        </b-col>
      </b-row>
      <!-- modal para visualizar todos os beneficios abordados -->
      <vs-popup
        class="benefits-utilized"
        title="Beneficios utilizados"
        :active.sync="modalToVisualize"
      >
        <div class="content-modal">
          <TableResult :beneficiosWithValue="beneficiosWithValue" />

          <b-row style="margin-top:20px; margin-right: -10px;">
            <vs-col
              v-if="observation != ''"
              style="margin-left: 16px;"
              type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="6"
            >
              <vs-card>
                <div slot="header">
                  <h4>Observação</h4>
                </div>
                <div>
                  <span>{{observation}}</span>
                </div>
              </vs-card>
            </vs-col>
            <b-col class="rigth-especific">
              <div class="div-right-float">
                <div class="total-reembolso">
                  <span class="reembolso left-especific margin-top-specific negrito">Total</span>
                  <money
                    v-model="total"
                    v-bind="money"
                    class="mask-input-invisible rigth-especific margin-top-specific mask-specific negrito"
                    disabled
                  />
                </div>
                <div class="total-reembolso" style="margin-top:20px !important">
                  <span class="reembolso left-especific margin-top-specific negrito">Total Previsto</span>
                  <money
                    v-model="totalprevisto"
                    v-bind="money"
                    class="mask-input-invisible rigth-especific margin-top-specific mask-specific negrito"
                    disabled
                  />
                </div>
                <div class="total-reembolso" style="margin-top:20px !important">
                  <span class="reembolso left-especific margin-top-specific negrito">Total Pago</span>
                  <money
                    v-model="totalpago"
                    v-bind="money"
                    class="mask-input-invisible rigth-especific margin-top-specific mask-specific negrito"
                    disabled
                  />
                </div>
              </div>
            </b-col>
          </b-row>
          <br />
          <footer class="footer-modal">
            <hr />
            <div class="btn-group">
              <div class="btn-space"></div>
              <div class="btn-print text-right">
                <b-button
                  @click="clickPrint"
                  style="width: 108.7px !important"
                  variant="info"
                >Imprimir</b-button>
              </div>
              <div v-if="!collaborator.aprove" class="btn-aprove text-right">
                <b-button
                  :disabled="isAlreadyClosed"
                  @click="clickAprove"
                  style="width: 108.7px !important"
                  variant="danger"
                >Aprovar</b-button>
              </div>
              <div v-else class="btn-aprove text-right">
                <b-button
                  :disabled="isAlreadyClosed"
                  @click="clickDesaprove"
                  variant="danger"
                >Desaprovar</b-button>
              </div>
            </div>
          </footer>
        </div>
      </vs-popup>
      <!-- <vs-popup fullscreen title="Relatorio de despesas" :active.sync="myModalRefPrint"> -->
      <PrintReportExpenses
        @closePopUpPrint="hideModalPrint"
        :loadingImport="loadingImport"
        :linkPrint="linkPrint"
        :event="'openPopUpPrintListExpenses'"
      />
      <!-- </vs-popup> -->
      <PopUpYesOrNo
        :message="'Você tem certeza de que quer Aprovar?'"
        :event="'popupActivoPopUpYesOrNo'"
        @closePopUpYesOrNo="hideModalYesOrNo"
        @clickYes="clickYes"
      />

      <PopUpYesOrNo
        :message="'Você tem certeza de que quer Desaprovar?'"
        :event="'popupActivoPopUpDesaprove'"
        @closePopUpYesOrNo="clickNoDesaprove"
        @clickYes="clickYesDesaprove"
      />
    </div>
    <section>
      <h1 class="title"></h1>
    </section>
  </div>
</template>

<script>
/* eslint-disable */
//components
import { Money } from "v-money";

import axios from "axios";

import { baseApiUrlRH, baseApiUrlReports } from "@/global";

import { EventBusExpenses } from "@/eventBus/eventBusExpenses";

import PrintReportExpenses from "@/components/modules/rh/Expenses/PrintReportExpenses";
import TableGrups from "@/components/modules/rh/Expenses/ListExpenses/TableGrups";
import TableCodeUser from "@/components/modules/rh/Expenses/ListExpenses/TableCodeUser";
import TableResult from "@/components/modules/rh/Expenses/ListExpenses/TableResult";
import PopUpYesOrNo from "@/components/modules/rh/Expenses/ListExpenses/PopUpYesOrNo";

export default {
  name: "ListExpenses",
  components: {
    Money,
    PrintReportExpenses,
    TableGrups,
    TableCodeUser,
    TableResult,
    PopUpYesOrNo
  },
  data() {
    return {
      observation: "",
      counterDanger: false,
      currentMoth: null,
      dateMask: "##/##/####",
      dateYear: "####",
      data: null,
      diaLimit: null,
      userContext: this.$store.state.userContext,
      nome: "",
      ano: 0,
      months: [
        { text: "Janeiro	  ", value: 0 },
        { text: "Fevereiro  ", value: 1 },
        { text: "Março	  ", value: 2 },
        { text: "Abril	  ", value: 3 },
        { text: "Maio	      ", value: 4 },
        { text: "Junho	  ", value: 5 },
        { text: "Julho	  ", value: 6 },
        { text: "Agosto	  ", value: 7 },
        { text: "Setembro   ", value: 8 },
        { text: "Outubro	  ", value: 9 },
        { text: "Novembro   ", value: 10 },
        { text: "Dezembro   ", value: 11 }
      ],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      total: 0.0,
      totalprevisto: 0.0,
      totalpago: 0.0,
      valuePermited: 0.0,
      fields: [
        { key: "slotBenGrupo", label: "" },
        { key: "grupoCodigo", label: "Cod." },
        "grupo"
      ],
      beneficiosPorCodeUser: [],
      beneficiosPorCodeUserClone: [],
      beneficiosCodeUserEspecifico: [],
      beneficiosPorGrupo: [],
      beneficiosGrupoEspecifico: [],
      beneficiosSend: [],
      beneficios: [],
      beneficiosWithValue: [],
      codeUser: "",
      userId: "",
      collaborator: {},
      loadingImport: false,
      modalToVisualize: false,
      linkPrint: "",
      isAlreadyClosed: false
    };
  },
  mounted() {
    this.listeningEventBus();
  },

  methods: {
    async alreadyClosed(currentMoth, ano) {
      this.isAlreadyClosed = await axios
        .get(
          `${baseApiUrlRH}/reportbenefits/alreadyClosed/${this.getYearMonth(
            currentMoth,
            ano
          )}`
        )
        .then(resp => resp.data);
    },

    clickNoDesaprove() {
      this.modalToVisualize = true;
    },

    async clickSaveObs() {
      this.observationExpenses();
    },

    async clickYesDesaprove() {
      this.$vs.loading();
      this.nome = await axios
        .get(
          `${baseApiUrlRH}/reportbenefits/deleteZRA010/${this.getYearMonthCurrent()}/${this.getBase64Encode(
            this.collaborator.id
          )}`
        )
        .then(resp => resp.data);
      this.showMessage("Desaprovado com Sucesso!!!", "danger");
      this.collaborator.aprove = false;

      let closed = {
        desaprove: null,
        collaboratorSelected: null
      };
      closed.desaprove = false;
      closed.collaboratorSelected = this.collaborator;
      this.$emit("onDesaprove", closed);

      this.$vs.loading.close();
      this.modalToVisualize = true;
    },

    async getName(collaborator, currentMoth, ano) {
      console.log(this.getYearMonth(currentMoth, ano));
      this.nome = await axios
        .get(
          `${baseApiUrlRH}/reportbenefits/getName/${this.getBase64Encode(
            collaborator.id
          )}/${this.getYearMonth(currentMoth, ano)}`
        )
        .then(resp => resp.data);
    },

    listeningEventBus() {
      EventBusExpenses.$on("data", data => {
        this.collaborator = data.collaborator;
        this.getUserId(this.collaborator, data.currentMoth, data.ano);
      });
    },

    getUserId(collaborator, currentMoth, ano) {
      this.getName(collaborator, currentMoth, ano);
      this.getLisBenefits(currentMoth, ano, collaborator);
      this.alreadyClosed(currentMoth, ano);
      this.getDayLimit(currentMoth, ano);
    },

    async getLisBenefits(currentMoth, ano, collaborator) {
      this.$vs.loading();
      this.observation = await axios
        .get(
          `${baseApiUrlRH}/reportbenefits/getObservationExpenses/${this.getYearMonth(
            currentMoth,
            ano
          )}/${this.getBase64Encode(collaborator.id)}`
        )
        .then(resp => resp.data);
      this.beneficios = await axios
        .get(
          `${baseApiUrlRH}/reportbenefits/list/${this.getYearMonth(
            currentMoth,
            ano
          )}/${this.getBase64Encode(collaborator.id)}`
        )
        .then(resp => resp.data);
      getPorGrupo(this);
      zeraValor(this);
      calculaTotal(this);
      calculaTotalPrevisto(this);
      calculaTotalPago(this);
      let vue = this;
      //atualiza o valores das subtabelas
      this.beneficios.forEach(function update(b) {
        getListGrupo(vue, b.grupoCodigo);
        if (b.hasOwnProperty("beneficiosCodeUser")) {
          b.beneficiosCodeUser.forEach(function update(bb) {
            getListCodeUser(vue, bb.codeUser, bb.grupoCodigo);
          });
        }
      });

      this.$vs.loading.close();
    },

    getYearMonth(currentMoth, ano) {
      var m =
        (currentMoth + 1 + "").length > 1
          ? currentMoth + 1
          : "0" + (currentMoth + 1);
      var anoMes = ano + "" + m;
      return anoMes;
    },

    getDayLimit(currentMoth, ano) {
      axios.get(`${baseApiUrlRH}/reportbenefits/getDiaLimit`).then(response => {
        this.diaLimit = response.data;
        this.getDateCurrent(this.diaLimit, currentMoth, ano);
      });
    },

    getDateCurrent(diaLimit, currentMoth, ano) {
      this.currentMoth = currentMoth;
      this.ano = ano;
      var m =
        (this.currentMoth + 1 + "").length > 1
          ? this.currentMoth + 1
          : "0" + (this.currentMoth + 1);
      this.data =
        ((diaLimit + "").length > 1 ? diaLimit : "0" + diaLimit) +
        "/" +
        m +
        "/" +
        ano;
    },

    async getName(collaborator, currentMoth, ano) {
      console.log(this.getYearMonth(currentMoth, ano));
      this.nome = await axios
        .get(
          `${baseApiUrlRH}/reportbenefits/getName/${this.getBase64Encode(
            collaborator.id
          )}/${this.getYearMonth(currentMoth, ano)}`
        )
        .then(resp => resp.data);
    },

    getBase64Encode(collaboratorId) {
      // return btoa(collaborator);
      // console.log(btoa(collaboratorId));
      return collaboratorId;
    },

    getYearMonthCurrent() {
      var m =
        (this.currentMoth + 1 + "").length > 1
          ? this.currentMoth + 1
          : "0" + (this.currentMoth + 1);
      var anoMes = this.ano + "" + m;
      return anoMes;
    },

    hideModalYesOrNo() {
      this.modalToVisualize = true;
    },

    hideModalPrint() {
      this.modalToVisualize = true;
    },

    hideModalVisualize() {
      this.modalToVisualize = false;
    },

    listBeneficioWithValue(vue) {
      vue.beneficiosWithValue = vue.beneficios.filter(function(elem) {
        return elem.valor > 0;
      });
    },

    clickVisualize() {
      this.listBeneficioWithValue(this);
      this.modalToVisualize = true;
    },

    async clickYes() {
      this.modalToVisualize = false;
      cloneBenefits(this);
      if (!this.collaborator.aprove) {
        this.prePayRollAll();
        this.observationExpenses();

        this.sendToProthuesTableZRA010(
          this.getYearMonthCurrent(),
          this.userContext,
          this.beneficiosSend
        );

        let closed = {
          aprove: null,
          collaboratorSelected: null
        };
        closed.aprove = true;
        closed.collaboratorSelected = this.collaborator;
        this.$emit("onAprove", closed);
        this.showMessage("Aprovado com Sucesso!!!", "danger");
      } else {
        this.showMessage("Essas despesas já foram aprovadas!!!", "danger");
      }
    },

    async prePayRollSpecific(beneficio) {
      // console.log(beneficio);
      if (!this.collaborator.aprove) {
        // cloneBenefits(this);
        let beneficiosSend = [];
        let bf = clone(beneficio);

        beneficiosSend.push(bf);
        let hasPrePayRoll = await axios
          .post(
            `${baseApiUrlRH}/reportbenefits/hasPrePayRoll/${this.getYearMonthCurrent()}/${this.getBase64Encode(
              this.collaborator.id
            )}`,
            bf
          )
          .then(resp => resp.data);
        if (hasPrePayRoll) {
          // console.log(beneficiosSend);
          if (beneficio.valor == 0.0) this.deletePrePayRoll(beneficiosSend);
          else this.updateValuePrePayRoll(beneficiosSend);
        } else {
          let data = await axios
            .post(
              `${baseApiUrlRH}/reportbenefits/insertPrePayRollWithoutSend/${this.getYearMonthCurrent()}/${this.getBase64Encode(
                this.collaborator.id
              )}`,
              beneficiosSend
            )
            .then(resp => resp.data);
        }
      }
    },

    async prePayRollAll() {
      let hasPrePayRoll = await axios
        .get(
          `${baseApiUrlRH}/reportbenefits/hasPrePayRoll/${this.getYearMonthCurrent()}/${this.getBase64Encode(
            this.collaborator.id
          )}`
        )
        .then(resp => resp.data);
      if (hasPrePayRoll) {
        this.updateValuePrePayRoll(this.beneficiosSend);
      } else {
        let data = await axios
          .post(
            `${baseApiUrlRH}/reportbenefits/insertPrePayRoll/${this.getYearMonthCurrent()}/${this.getBase64Encode(
              this.collaborator.id
            )}`,
            this.beneficiosSend
          )
          .then(resp => resp.data);
      }
    },

    async observationExpenses() {
      this.$vs.loading();
      let hasObservationExpenses = await axios
        .get(
          `${baseApiUrlRH}/reportbenefits/hasObservationExpenses/${this.getYearMonthCurrent()}/${this.getBase64Encode(
            this.collaborator.id
          )}`
        )
        .then(resp => resp.data);
      console.log("teste --------------" + this.observation);
      let descprition = this.observation == "" ? "''" : this.observation;
      if (hasObservationExpenses) {
        let isOk = await axios
          .get(
            `${baseApiUrlRH}/reportbenefits/updateObservationExpenses/${this.getYearMonthCurrent()}/${this.getBase64Encode(
              this.collaborator.id
            )}/${descprition}`
          )
          .then(resp => resp.data);
        this.showMessage("Observação foi alterada com sucesso!!!", "danger");
      } else {
        let data = await axios
          .get(
            `${baseApiUrlRH}/reportbenefits/insertObservationExpenses/${this.getYearMonthCurrent()}/${this.getBase64Encode(
              this.collaborator.id
            )}/${descprition}`
          )
          .then(resp => resp.data);
        this.showMessage("Observação foi inserida com sucesso!!!", "danger");
      }
      this.$vs.loading.close();
    },

    showMessage(message, type) {
      this.$vs.notify({
        title: "Aviso",
        text: message,
        color: type
      });
    },

    clickAprove() {
      EventBusExpenses.$emit("popupActivoPopUpYesOrNo", true);
      this.modalToVisualize = false;
    },

    clickDesaprove() {
      EventBusExpenses.$emit("popupActivoPopUpDesaprove", true);
      this.modalToVisualize = false;
    },

    clickPrint() {
      this.loadingImport = true;
      EventBusExpenses.$emit("openPopUpPrintListExpenses", true);
      this.modalToVisualize = false;
      var m =
        (this.currentMoth + 1 + "").length > 1
          ? this.currentMoth + 1
          : "0" + (this.currentMoth + 1);
      var dateBenefits =
        this.ano +
        "-" +
        m +
        "-" +
        ((this.diaLimit + "").length > 1 ? this.diaLimit : "0" + this.diaLimit);
      this.linkPrint = `${baseApiUrlReports}/print/benefits/${dateBenefits}/${this.getBase64Encode(
        this.collaborator.id
      )}/${false}`;
      setTimeout(() => {
        this.loadingImport = false;
      }, 1000);
    },

    async sendToProthuesTableZRA010(anoMes, userContext, beneficiosSend) {
      let data = await axios
        .post(
          `${baseApiUrlRH}/reportbenefits/insertZRA010/${anoMes}/${
            userContext.userId
          }/${this.getBase64Encode(this.collaborator.id)}`,
          beneficiosSend
        )
        .then(resp => resp.data);
      if (data != null) console.log("aprovado");
    },

    async updateValuePrePayRoll(beneficiosSend) {
      let data = await axios

        .post(
          `${baseApiUrlRH}/reportbenefits/updateValuePrePayRoll/${this.getYearMonthCurrent()}/${this.getBase64Encode(
            this.collaborator.id
          )}`,
          beneficiosSend
        )
        .then(resp => resp.data);
      if (data != null) console.log("alterado");
    },

    async deletePrePayRoll(beneficiosSend) {
      let data = await axios

        .post(
          `${baseApiUrlRH}/reportbenefits/deletePrePayRoll/${this.getYearMonthCurrent()}/${this.getBase64Encode(
            this.collaborator.id
          )}`,
          beneficiosSend
        )
        .then(resp => resp.data);
      if (data != null) console.log("apagado");
    },

    async changevalue(beneficio) {
      if (beneficio.valor == 0)
        beneficio.seeWhenPassInCheckValueAndZero = false;
      else beneficio.seeWhenPassInCheckValueAndZero = true;
      this.checkValue(beneficio, true);
      calculaTotal(this);
      let closed = {
        total: null,
        collaboratorSelected: null
      };
      closed.total = this.total;
      closed.collaboratorSelected = this.collaborator;
      this.$emit("onClosedListExpenses", closed);
      // this.prePayRollSpecific(beneficio);
    },

    changeDate() {
      this.ano = this.data.substring(6, 10);
      var mes = this.data.substring(3, 5);
      this.currentMoth = mes - 1;
    },

    changeYear() {
      var m =
        (this.currentMoth + 1 + "").length > 1
          ? this.currentMoth + 1
          : "0" + (this.currentMoth + 1);
      this.data =
        ((this.diaLimit + "").length > 1
          ? this.diaLimit
          : "0" + this.diaLimit) +
        "/" +
        m +
        "/" +
        this.ano;
    },

    changeMoth() {
      var m =
        (this.currentMoth + 1 + "").length > 1
          ? this.currentMoth + 1
          : "0" + (this.currentMoth + 1);
      this.data =
        ((this.diaLimit + "").length > 1
          ? this.diaLimit
          : "0" + this.diaLimit) +
        "/" +
        m +
        "/" +
        this.ano;
      this.getLisBenefits(this.currentMoth, this.ano, this.collaborator);
    },

    checkValue(beneficio, isChange) {
      this.checkOnValue(beneficio, isChange);
      if (beneficio.grupoCodigo == "02" && beneficio.beneficioCodigo == "02") {
        zeraGrupo2Beneficio3(this);
        getValueAuxDespVeiculo03(this);
      }
    },

    async checkOnValue(beneficio, isChange) {
      let calculo = calculaTotalDoGrupo(this, beneficio);
      console.log(calculo);
      // console.log(beneficio.valor)
      this.permited = await axios
        .get(
          `${baseApiUrlRH}/reportbenefits/verifyValuePermited/${
            beneficio.grupoCodigo
          }/${beneficio.beneficioCodigo}/${calculo}/${
            beneficio.codeUser
          }/${this.getBase64Encode(this.collaborator.id)}/${beneficio.valor}`
        )
        .then(resp => resp.data);
      this.valuePermited = this.permited.value;
      beneficio.valuePermited = this.permited.value;

      // console.log(this.permited.value)

      if (
        beneficio.grupoCodigo == "02" &&
        (beneficio.beneficioCodigo == "03" || beneficio.beneficioCodigo == "01")
      )
        beneficio.valor = this.permited.value;
      if (this.permited.isBiggerThan) {
        beneficio.valor = 0.0;
        this.showMessage(
          `Valor do Beneficio é superior ao valor proposto de:  ${this.valuePermited}`,
          "danger"
        );
        beneficio.valuePermited = 0.0;
        return;
      }
      //para o calculo do total previsto
      if (
        beneficio.grupoCodigo != "10" &&
        beneficio.grupoCodigo != "15" &&
        beneficio.grupoCodigo != "17" &&
        beneficio.grupoCodigo != "18" &&
        beneficio.grupoCodigo != "19" &&
        beneficio.grupoCodigo != "20" &&
        beneficio.grupoCodigo != "21" &&
        beneficio.grupoCodigo != "04" &&
        beneficio.grupoCodigo != "05"
      )
        beneficio.valuePermited = 0.0;

      if (
        beneficio.grupoCodigo == "04" &&
        beneficio.beneficioCodigo != "01" &&
        beneficio.beneficioCodigo != "02"
      )
        beneficio.valuePermited = 0.0;

      if (beneficio.valuePermited < 0) beneficio.valuePermited = 0.0;
      if (beneficio.valor < 0) beneficio.valor = 0.0;

      if (isChange) this.prePayRollSpecific(beneficio);
      calculaTotal(this);
      calculaTotalPrevisto(this);
      calculaTotalPago(this);
    },

    open(grupoCodigo) {
      getListGrupo(this, grupoCodigo);
    },

    openCodeUser(codeUser, grupoCodigo) {
      getListCodeUser(this, codeUser, grupoCodigo);
    },

    openShowDetail(beneficioCodeUser) {
      if (beneficioCodeUser._showDetail) beneficioCodeUser._showDetail = false;
      else beneficioCodeUser._showDetail = true;
    }
  }
};

//clona o beneficios
function cloneBenefits(vue) {
  vue.beneficiosSend = [];
  vue.beneficios.forEach(function addAtributo(b) {
    vue.beneficiosSend.push(clone(b));
  });
}
//cria uma nova instancia de beneficio
function clone(b) {
  let benefit = {};
  benefit.id = b.id;
  benefit.grupo = b.grupo;
  benefit.grupoCodigo = b.grupoCodigo;
  benefit.beneficio = b.beneficio;
  benefit.beneficioCodigo = b.beneficioCodigo;
  benefit.valor = b.valor;
  benefit.origem = b.origem;
  benefit.titular = b.titular;
  benefit.dependente = b.dependente;
  benefit.codeUser = b.codeUser;
  benefit.nomeFuncionario = b.nomeFuncionario;
  benefit.origens = b.origens;
  benefit.valuePermited = b.valuePermited;
  benefit.valorPago = b.valorPago;
  return benefit;
}

function zeraValor(vue) {
  vue.total = 0.0;
  vue.beneficios.forEach(function calculo(b) {
    if (b.grupoCodigo != "01") b.valor = 0.0;
    if (b.grupoCodigo == "02" && b.beneficioCodigo == "01")
      vue.checkValue(b, false); //para colocar o valor com as regras corretas no valor do beneficio
    if (b.valorReal > 0) b.valor = b.valorReal;
  });
}

function getValueAuxDespVeiculo03(vue) {
  vue.beneficios.forEach(function calculo(b) {
    if (b.grupoCodigo == "02" && b.beneficioCodigo == "03") {
      vue.checkOnValue(b, true); //pega o valor do beneficio 03 do grupo 02 em especifico
    }
  });
}

function zeraGrupo2Beneficio3(vue) {
  vue.beneficios.forEach(function calculo(b) {
    if (b.grupoCodigo == "02" && b.beneficioCodigo == "03") {
      b.valor = 0.0;
    }
  });
}

//faz a soma de todos os valores dos beneficios
function calculaTotal(vue) {
  vue.total = 0.0;
  vue.beneficios.forEach(function calculo(b) {
    vue.total += b.valor;
  });
}

function calculaTotalPrevisto(vue) {
  vue.totalprevisto = 0.0;
  vue.beneficios.forEach(function calculo(b) {
    if (
      b.valuePermited != "" &&
      b.valuePermited != 0 &&
      b.hasOwnProperty("valuePermited")
    ) {
      vue.totalprevisto += b.valuePermited;
    } else {
      vue.totalprevisto += b.valor;
    }
  });
}

function calculaTotalPago(vue) {
  vue.totalpago = 0.0;
  vue.beneficios.forEach(function calculo(b) {
    vue.totalpago += b.valorPago;
  });
}

function calculaTotalDoGrupo(vue, beneficio) {
  if (
    beneficio.grupoCodigo != "04" &&
    beneficio.grupoCodigo != "08" &&
    beneficio.grupoCodigo != "02"
  )
    return beneficio.valor;
  let total = 0.0;

  if (beneficio.grupoCodigo == "02") {
    vue.beneficios.forEach(function calculo(b) {
      if (
        beneficio.grupoCodigo == b.grupoCodigo &&
        b.grupoCodigo == "02" &&
        b.beneficioCodigo != "03"
      )
        total += b.valor;
    });
  } else {
    vue.beneficios.forEach(function calculo(b) {
      if (beneficio.grupoCodigo == b.grupoCodigo) total += b.valor;
    });
  }
  return total;
}

//quebra a lista em grupos
function getPorGrupo(vue) {
  vue.beneficiosPorGrupo = [];
  vue.beneficios.forEach(function contains(b) {
    vue.beneficiosPorGrupo.push(b);
    let i = 0;
    vue.beneficiosPorGrupo.forEach(function contains(bg) {
      if (b.grupoCodigo === bg.grupoCodigo) {
        i++;
      }
    });

    if (i > 1) {
      var index = vue.beneficiosPorGrupo.indexOf(b);
      if (index > -1) vue.beneficiosPorGrupo.splice(index, 1);
    }
  });
}

function getPorCodeUserPorBeneficioEspecifico(vue) {
  vue.beneficiosPorCodeUser = [];
  vue.beneficiosGrupoEspecifico.forEach(function contains(b) {
    vue.beneficiosPorCodeUser.push(b);
    let i = 0;
    vue.beneficiosPorCodeUser.forEach(function contains(bc) {
      if (b.codeUser === bc.codeUser) {
        i++;
      }
    });

    if (i > 1) {
      var index = vue.beneficiosPorCodeUser.indexOf(b);
      if (index > -1) vue.beneficiosPorCodeUser.splice(index, 1);
    }

    //clona para ser objetos diferentes
    vue.beneficiosPorCodeUserClone = [];
    vue.beneficiosPorCodeUser.forEach(function contains(b) {
      let bc = clone(b);
      bc._showDetail = false;
      vue.beneficiosPorCodeUserClone.push(bc);
    });
  });
}

//insere os beneficios na lista de grupos
function getListGrupo(vue, grupoCodigo) {
  vue.beneficiosGrupoEspecifico = vue.beneficios.filter(function(elem) {
    return elem.grupoCodigo === grupoCodigo;
  });
  getPorCodeUserPorBeneficioEspecifico(vue);
  vue.beneficiosPorGrupo.forEach(function contains(b) {
    if (b.grupoCodigo === grupoCodigo) {
      b.beneficios = [];
      b.beneficiosCodeUser = [];
      Array.prototype.push.apply(b.beneficios, vue.beneficiosGrupoEspecifico);
      Array.prototype.push.apply(
        b.beneficiosCodeUser,
        vue.beneficiosPorCodeUserClone
      );
      if (vue.beneficiosPorCodeUser.length > 1) b.isCodeUser = true;
      else b.isCodeUser = false;
    }
  });
}

function getListCodeUser(vue, codeUser, grupoCodigo) {
  vue.beneficiosCodeUserEspecifico = vue.beneficiosGrupoEspecifico.filter(
    function(elem) {
      return elem.codeUser === codeUser;
    }
  );

  vue.beneficiosPorGrupo.forEach(function contains(b) {
    if (b.grupoCodigo === grupoCodigo) {
      b.beneficiosCodeUser.forEach(function contains(bb) {
        if (bb.codeUser === codeUser) {
          bb.beneficiosCodeUsers = [];
          Array.prototype.push.apply(
            bb.beneficiosCodeUsers,
            vue.beneficiosCodeUserEspecifico
          );
        }
      });
    }
  });
  vue.beneficiosPorCodeUserClone.forEach(function contains(b) {
    if (b.codeUser === codeUser) {
      b.beneficiosCodeUsers = [];
      Array.prototype.push.apply(
        b.beneficiosCodeUsers,
        vue.beneficiosCodeUserEspecifico
      );
    }
  });
}
</script>

<style scoped src="./list-expenses.css" ></style>
